/* eslint-disable */
import classNames from 'classnames';
import React from 'react';
import './Tabs.css';

export default class Tabs extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayName: 'Tabs',
      selected: props.selected
    }
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let _state = this.state;
    nextProps.selected !== this.state.selected
      ? _state['selected'] = nextProps.selected
      : '';
    this.setState(_state);
  }

  handleClick(child, index, event) {
    event.preventDefault();
    if (this.props.useReduxHandler) {
      this.props.setCurrentActiveTab(index);
    } else if (this.props.landingHandler) {
      this.props.setLandingActiveTab(index);
    } else {
      this.setState({ selected: index });
    }

    if (typeof this.props.onTabChange === "function") {
      this.props.onTabChange(index);
    }
    // let arrObj=[];
    // !Array.isArray(this.props.children) ? arrObj.push(this.props.children) : "";
    // if(arrObj.length > 0){
    //   if(arrObj[0].props.callbackFun){
    //     arrObj[0].props.onTabChange();
    //   }
    // }else{
    //   if(child.props.children[index].props.callbackFun){
    //     child.props.children[index].props.onTabChange();
    //   }
    // }
  }

  checkStatus(child, activeClass) {  // Tab status-> get icon status
    let classNameIcon = "";
    if (!child.props.disabled) {
      if (child.props.status === true) {
        if (activeClass === 'active') {
          classNameIcon = 'icon icon-circle-confirmation-solid gdoc-tab-tabopen';
        } else {
          classNameIcon = 'icon icon-circle-confirmation-solid gdoc-tab-tabclose';
        }
      } else if (child.props.status !== undefined) {
        if (activeClass === 'active') {
          classNameIcon = 'icon icon-circle-error-solid gdoc-tab-tabwarning';
        } else {
          classNameIcon = 'icon icon-circle-error-solid gdoc-tab-tabclose';
        }
      }
      else {
        classNameIcon = undefined
      }
    }
    return classNameIcon;
  }

  _renderTitles(_children) {

    function labels(child, index) {
      let activeClass = this.state.selected === index ? 'active' : '';
      let ariaCurrent = this.props.ariaSelected === index ? "page" : "false"
      const activeAnchour = activeClass ? 'gdoc-tab-activeAnchour' : ''
      const classesAnchour = child.props.disabled ? `${activeAnchour} disabled` : ``;
      const classNameIconValue = this.checkStatus(child, activeClass);
      const styleVisibility = {
        visibility: child.props.disabled ? 'hidden' : 'visible'
      }

      return (
        <li key={index} className={activeClass}>
          <a data-toggle="tab" href="#"
            className={classesAnchour}
            id="gdocs-tab__focusable"
            aria-selected={activeClass === 'active' ? 'true' : 'false'}
            // aria-current={ariaCurrent}
            onClick={this.handleClick.bind(child, this, index)}
            tabIndex={(classesAnchour === " disabled") ? "-1" : "0"}
            aria-disabled={(classesAnchour === " disabled") ? "true" : "false"}
            role='tab'
          >
            {/* check for tabs that do not need a status icon and disabled tabs */}
            {classNameIconValue !== undefined && !child.props.disabled
              ? <i style={styleVisibility} className={classNameIconValue} role='img' aria-label={classNameIconValue === "icon icon-circle-error-solid gdoc-tab-tabwarning" ? "status-pending" : "status-complete"}>
                {!activeClass && classNameIconValue === 'icon icon-circle-error-solid gdoc-tab-tabwarning' ? <i className=""></i> : ''}
              </i>
              : null
            }
            <h2 className="gdoc-tab-labelText">{child.props.label}</h2>
            <span className={child.props.numbericValue ? "gdoc-tab-numberRe" : ""}>
              {child.props.numbericValue ? child.props.numbericValue : ''}
            </span>
          </a>
        </li>
      );
    }

    return (
      <ul className={classNames("gdoc-tab-nav gdoc-tab-nav-tabs gdocs-nav-tabs-flex ", { "gdocs-h-100": this.props.pathname === "/case-list" })} role='tablist'>
        {_children.map(labels.bind(this))}
      </ul>
    );
  }


  _renderContent(_children) {
    const staticClass = this.props.contentClass ? this.props.contentClass + ' gdoc-tab-tab-content' : `gdoc-tab-tab-content`;
    return (
      <div className={staticClass} role='tabpanel'>
        {_children[this.state.selected]}
      </div>
    );
  }

  render() {
    var _children = [];
    //var _selected = 0;
    if (!Array.isArray(this.props.children)) {
      // incase of one tab
      _children.push(this.props.children);
    } else {
      // incase of multiple tabs
      _children = this.props.children;
    }
    _children = _children.filter(child => child !== "");

    // _selected = this.props.selected < _children.length ? this.props.selected : _children.length-1;
    return (
      <div className="gdoc-tab-tabs">
        {
          this.props.customer
            ? (this.props.sow ? this._renderTitles(_children) : '')
            : this._renderTitles(_children)
        }
        {this._renderContent(_children)}
      </div>
    );
  }
}

Tabs.defaultProps = {
  selected: 0,
  useReduxHandler: false,
  customer: false
}


// WEBPACK FOOTER //
// ./src/components/common/Tabs/Tabs.js